import { render, staticRenderFns } from "./FunFact.vue?vue&type=template&id=12ebbb0a&"
import script from "./FunFact.vue?vue&type=script&lang=js&"
export * from "./FunFact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports